import React, { useEffect, useState } from "react";
import { getMainBookList, getNewAuthor } from "../../api";
import { useIsMobile } from "../../hooks/useIsMobile";
import AddNewAuthor from "./ui/AddNewAuthor";
import GetColor from "../controls/GetColor";
import MainLayout from "./MainLayout";


interface Book {
    bookId: number;
    bookTitle: string;
    bookPublicationReason: string;
    author: {
        authorName: string;
        profilePhoto: string;
    };
    coverImage: string;
    backgroundColor: string;
}


import usePageTitle from "../../hooks/usePageTitle";

export default function MainPageContainer() {
    usePageTitle("북밋 작가 이야기");

    const getDummyBooks = (): Book[] => {
        return [
            {
                bookId: 1,
                bookTitle: "샘플 책제목1",
                bookPublicationReason: "하늘의 해도 탐내고 있어 해를 삼킬 큰 물결을 만들자 탐나는 빛을 가진 너마저 널 의심하게 될 테지만 믿어",
                author: {
                    authorName: "조수연",
                    profilePhoto: ""
                },
                coverImage: ``,
                backgroundColor: "rgba(200, 255, 239, 0.7)"
            },
            {
                bookId: 2,
                bookTitle: "샘플 책제목2",
                bookPublicationReason: "커다란 파동을 일으키는 그 힘을 너도 가지고 있어 내게 보여줄래 파란을 일으켜 눈부신 널 보여줘",
                author: {
                    authorName: "하서빈",
                    profilePhoto: ""
                },
                coverImage: ``,
                backgroundColor: "rgba(180, 255, 220, 0.7)"
            },
            {
                bookId: 3,
                bookTitle: "샘플 책제목3",
                bookPublicationReason: "처음은 미약한 물결이겠지만 그렇게 너의 꿈에 닿을 수 있겠지 거대한 바다에 갇혀버린 너를 구할 방법을 알고 있어",
                author: {
                    authorName: "최수빈",
                    profilePhoto: ""
                },
                coverImage: ``,
                backgroundColor: "rgba(180, 220, 240, 0.7)"
            }
        ];
    };


    const isMobile = useIsMobile();
    const [authors, setAuthors] = useState([]);
    const [bookData, setBookData] = useState<Book[]>([]);
    const [carouselImages, setCarouselImages] = useState<any>([]);

    useEffect(() => {
        const fetchAuthors = async () => {
            const data = await getNewAuthor();
            setAuthors(data);
        };

        const fetchBooks = async () => {
            const data = await getMainBookList();


            if (Array.isArray(data)) {

                setBookData(data);
            } else {
                setBookData([]);
                setBookData(getDummyBooks());
                //  console.warn('getMainBookList returned non-array:', data);
            }

        };

        fetchAuthors();
        fetchBooks();
    }, []);

    useEffect(() => {
        const generateCarouselData = async () => {
            const images = await Promise.all(
                bookData.map(async (book) => {
                    const bgColor = `rgba(${(await GetColor(book.coverImage)).join(", ")}, 0.7)`;

                    return {
                        id: book.bookId,
                        title: book.bookTitle,
                        phrase: book.bookPublicationReason,
                        author: book.author.authorName,
                        profile: book.author.profilePhoto,
                        src: book.coverImage,
                        alt: `book-image-${book.bookTitle}`,
                        backgroundColor: bgColor,
                    };
                })
            );
            setCarouselImages(images);
        };

        if (Array.isArray(bookData) && bookData.length > 0) {
            generateCarouselData();
        }
    }, [bookData, isMobile]);


    return (
        <MainLayout
            authors={authors}
            carouselImages={carouselImages}
            isMobile={isMobile}
            AddAuthorComponent={AddNewAuthor}
        />
    );
}
